import { MarketplaceProductTypeEnum } from '@cc-shopping/contracts/cross-site/marketplace/enums';
import type { CreditCardOffer } from '@cc-shopping/contracts/cross-site/marketplace/types';
import { FinishType } from '@cc-shopping/platform-analytics/types';
import { SECTION_NAME, SECTION_POSITION } from './utils';

export const getAnalyticsProps = (creditCardOffer: CreditCardOffer, index: number) => {
  const {
    details: { isReview, applyLink, reviewLink },
  } = creditCardOffer;
  return isReview
    ? {}
    : {
        finishType: FinishType.ExternalApplication,
        hasPrequalified: false,
        includeClickHeaderParams: true,
        productPosition: index,
        monetizable: creditCardOffer.details.monetizable,
        entityId: creditCardOffer.legacyAnalytics.productId,
        marketplacePayload: {
          destination_url: isReview ? reviewLink : applyLink,
          marketplace_product_type: MarketplaceProductTypeEnum.CreditCards,
          monetizable: creditCardOffer.details.monetizable,
          element_position: SECTION_POSITION,
          marketplace_institution_id: creditCardOffer.legacyAnalytics.institutionId,
          marketplace_offer_id: creditCardOffer.id,
          marketplace_product_id: creditCardOffer.legacyAnalytics.productId,
          section_name: SECTION_NAME,
          section_position: SECTION_POSITION,
        },
        section: {
          name: SECTION_NAME,
          position: SECTION_POSITION,
          category: 'ProductSummaryTable',
        },
        productSlug: creditCardOffer?.legacyAnalytics?.legacySlug,
      };
};
